const MONTH_MAP = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12"
};
const getDateBanner = (dateStamp) => {
  const dateParts = dateStamp.split("T")[0].split("-");
  const year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const day = parseInt(dateParts[2], 10);
  const eventDate = new Date(year, month, day);
  const currentDate = /* @__PURE__ */ new Date();
  currentDate.setHours(0, 0, 0, 0);
  const weekFromNow = /* @__PURE__ */ new Date();
  weekFromNow.setDate(currentDate.getDate() + 7);
  weekFromNow.setHours(0, 0, 0, 0);
  if (eventDate.getFullYear() === currentDate.getFullYear() && eventDate.getMonth() === currentDate.getMonth() && eventDate.getDate() === currentDate.getDate()) {
    return "Today";
  }
  if (eventDate.getTime() > currentDate.getTime() && eventDate.getTime() <= weekFromNow.getTime()) {
    const days2 = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];
    return days2[eventDate.getDay()];
  }
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  return `${days[eventDate.getDay()]}, ${months[eventDate.getMonth()]} ${eventDate.getDate()}`;
};
const parseLocalDate = (dateString) => {
  const parts = dateString.split("-");
  const date = new Date(
    parseInt(parts[0], 10),
    parseInt(parts[1], 10) - 1,
    parseInt(parts[2], 10)
  );
  date.setHours(0, 0, 0, 0);
  return date;
};
const getEventStartDate = (event) => {
  return parseLocalDate(event.startStamp.split("T")[0]);
};
const isMultiDayEvent = (event) => {
  const startParts = event.startStamp.split("T")[0].split("-");
  const startMonth = startParts[1];
  const startDay = startParts[2];
  const endMonth = MONTH_MAP[event.endMonth || ""];
  const endDay = (event.endDay || "").padStart(2, "0");
  return !(startMonth === endMonth && startDay === endDay);
};
const eventStartsOnDate = (event, targetDate) => {
  const eventStartDate = getEventStartDate(event);
  return eventStartDate.getTime() === targetDate.getTime();
};
const getEventPriority = (event, groupDate) => {
  const isMulti = isMultiDayEvent(event);
  const startsOnDate = eventStartsOnDate(event, groupDate);
  if (isMulti && startsOnDate) return 1;
  if (!isMulti) return 2;
  return 3;
};
const sortEventsByPriority = (events, groupDate) => {
  return [...events].sort((a, b) => {
    const aPriority = getEventPriority(a, groupDate);
    const bPriority = getEventPriority(b, groupDate);
    return aPriority - bPriority;
  });
};
const groupEventsByDate = (events) => {
  const currentDate = /* @__PURE__ */ new Date();
  currentDate.setHours(0, 0, 0, 0);
  const grouped = events.reduce((acc, event) => {
    const eventDate = getEventStartDate(event);
    const dateKey = eventDate < currentDate ? currentDate.toISOString().split("T")[0] : event.startStamp;
    if (!acc[dateKey]) {
      acc[dateKey] = {
        date: getDateBanner(dateKey),
        events: []
      };
    }
    acc[dateKey].events.push(event);
    return acc;
  }, {});
  Object.keys(grouped).forEach((dateKey) => {
    const groupDate = parseLocalDate(dateKey);
    grouped[dateKey].events = sortEventsByPriority(
      grouped[dateKey].events,
      groupDate
    );
  });
  return Object.values(grouped).sort((a, b) => {
    const dateA = new Date(
      Object.keys(grouped).find((key) => grouped[key] === a) || ""
    );
    const dateB = new Date(
      Object.keys(grouped).find((key) => grouped[key] === b) || ""
    );
    return dateA.getTime() - dateB.getTime();
  });
};
export {
  eventStartsOnDate,
  getDateBanner,
  getEventPriority,
  getEventStartDate,
  groupEventsByDate,
  isMultiDayEvent,
  parseLocalDate,
  sortEventsByPriority
};
//# sourceMappingURL=events.js.map
